import { connect }                           from 'react-redux';
import { onChangeParameter, onQuoteRequest } from 'pu-redux/actions/QuoteActions';
import Parameters                            from '../components/Parameters';

const mapStateToProps = state => ({
  parameters       : state.get('parameters').toJS(),
  quoteStep        : state.get('quoteStep'),
  parametersChanged: state.get('parametersChanged'),
  suppliers        : state.get('suppliers'),
});

const mapActionsToProps = {
  onChangeParameter,
  onQuoteRequest,
};

export default connect(mapStateToProps, mapActionsToProps)(Parameters);
